import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import IconButton from "../../../../IconButton";
import { IconButtonWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function IconButtonAdornment(props) {
  return /*#__PURE__*/_jsx(IconButtonWrapper, {
    children: /*#__PURE__*/_jsx(IconButton, _extends({}, props))
  });
}